/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The priority of the ticket
 * @nullable
 */
export enum FetchTicketResponsePriority {
  high= 'high',
  medium= 'medium',
  lows= 'lows',
  null= null,

}